import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { AppToastService } from 'src/app/shared/services/app-toast.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AuthLayoutComponent } from '../auth-layout/auth-layout.component';

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    InputTextModule,
    AuthLayoutComponent,
  ],
})
export class ForgotPasswordPageComponent implements OnInit {
  forgotForm: UntypedFormGroup;

  constructor(
    private authService: AuthService,
    private readonly toastService: AppToastService,
    private router: Router,
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit() {
    if (this.forgotForm.valid) {
      const user = Object.assign({}, this.forgotForm.value);

      this.authService.forgotPassword(user).subscribe({
        next: () => {
          this.toastService.success('Success', 'A password reset link was sent. Check your email.');
          this.router.navigate(['login']);
        },
        error: () => {},
      });
    }
  }
}